import {createUseStyles} from 'react-jss';
import cn from 'classnames';
import React, {FunctionComponent} from 'react';
import {IconProps} from './IconProps';

const IconOnline: FunctionComponent<IconProps> = ({className, height = '1em'}) => {
  const styles = useStyles();

  return (
    <svg height={height} viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"
      className={cn('inline-block', className, styles.icon)}>
      <g clipPath="url(#clip0)">
        <circle cx="8" cy="7.5" r="6.5" stroke="#4A90E2"/>
        <path
          d="M14.5 7.49935C14.5 7.60265 14.4377 7.78064 14.1404 8.01488C13.8488 8.24469 13.3959 8.4735 12.7916 8.67492C11.5883 9.07602 9.89421 9.33268 8 9.33268C6.10579 9.33268 4.41166 9.07602 3.20837 8.67492C2.60411 8.4735 2.15118 8.24469 1.85958 8.01488C1.56235 7.78064 1.5 7.60265 1.5 7.49935C1.5 7.39605 1.56235 7.21806 1.85958 6.98382C2.15118 6.75401 2.60411 6.52519 3.20837 6.32377C4.41166 5.92268 6.10579 5.66602 8 5.66602C9.89421 5.66602 11.5883 5.92268 12.7916 6.32377C13.3959 6.52519 13.8488 6.75401 14.1404 6.98382C14.4377 7.21806 14.5 7.39605 14.5 7.49935Z"
          stroke="#4A90E2"/>
        <path
          d="M11 7.5C11 9.37221 10.6195 11.0424 10.0277 12.2261C9.42086 13.4397 8.67508 14 8 14C7.32492 14 6.57914 13.4397 5.97234 12.2261C5.38049 11.0424 5 9.37221 5 7.5C5 5.62779 5.38049 3.95755 5.97234 2.77386C6.57914 1.56026 7.32492 1 8 1C8.67508 1 9.42086 1.56026 10.0277 2.77386C10.6195 3.95755 11 5.62779 11 7.5Z"
          stroke="#4A90E2"/>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="14" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
      </defs>
    </svg>

  );
};

export default IconOnline;

const useStyles = createUseStyles({
  icon: {
    verticalAlign: '-0.125em',
  },
});
